import { usePatreonLink } from "../../lib/patreon";
import { PatreonPremium } from "./PatreonPremium";
import { GoldChip } from "../ui/Gold";

/**
 * The Premium card: where a person comes to see what Patreon says about them, ask
 * again, or sever the link. Absent entirely on a box with no Patreon (the server
 * answers `enabled: false`), and for anyone signed out — a card that says "nothing to
 * do here" is not a card.
 *
 * It sat on /profile until 2026-09-20 and moved to /settings, which is where someone
 * looks for a thing they manage rather than a thing they achieved. That move is why
 * `source` says "settings": the string is a closed vocabulary on BOTH sides
 * (PatreonCtaSource in lib/gold.ts and PATREON_SOURCES in server/src/patreon.ts), so
 * it cannot be changed in one place — a source the server does not know is dropped
 * silently, which is a funnel that quietly measures nothing.
 */
export function PatreonCard() {
  const patreon = usePatreonLink();
  if (!patreon.state?.enabled) return null;
  return (
    <section className="rounded-xl border border-[var(--color-edge)] bg-[var(--color-panel)] p-4">
      <h2 className="mb-3 flex items-center gap-2 text-sm font-semibold text-zinc-100">
        Premium <GoldChip />
        <span className="text-xs font-normal text-zinc-500">via Patreon</span>
      </h2>
      <PatreonPremium
        state={patreon.state}
        busy={patreon.busy}
        connect={patreon.connect}
        refresh={patreon.refresh}
        refreshQuiet={patreon.refreshQuiet}
        disconnect={patreon.disconnect}
        source="settings"
        compact
      />
    </section>
  );
}
